import type { ReactNode } from 'react';
import { HelpContentKey } from '../constants/helpContent';

export type WorkspaceMenuItem =
  | {
      kind: 'item';
      id: string;
      label: string;
      disabled: boolean;
      helpTooltip: string;
      onClick: () => void;
      icon?: ReactNode;
    }
  | { kind: 'divider' };

export type WorkspaceMenuSection = {
  id: string;
  label: string;
  items: WorkspaceMenuItem[];
  hidden?: boolean;
};

export type WorkspaceQuickAction = {
  id: string;
  label: string;
  disabled: boolean;
  helpTooltip: string;
  onClick: () => void;
  icon: ReactNode;
};

export type WorkspaceMenuItemSpec = {
  id: string;
  label: string;
  helpKey: HelpContentKey;
  enabled: boolean;
  onClick: () => void;
  hidden?: boolean;
};

export function menuItemFromSpec(
  spec: WorkspaceMenuItemSpec,
  tooltipFor: (key: HelpContentKey, enabled: boolean) => string,
  iconFor?: (id: string) => ReactNode | undefined,
): WorkspaceMenuItem | null {
  if (spec.hidden) return null;
  return {
    kind: 'item',
    id: spec.id,
    label: spec.label,
    disabled: !spec.enabled,
    helpTooltip: tooltipFor(spec.helpKey, spec.enabled),
    onClick: spec.onClick,
    icon: iconFor?.(spec.id),
  };
}

export function menuDivider(): WorkspaceMenuItem {
  return { kind: 'divider' };
}

export function compactMenuItems(items: WorkspaceMenuItem[]): WorkspaceMenuItem[] {
  const out: WorkspaceMenuItem[] = [];
  for (const item of items) {
    if (item.kind === 'divider') {
      if (out.length > 0 && out[out.length - 1].kind !== 'divider') {
        out.push(item);
      }
      continue;
    }
    out.push(item);
  }
  while (out.length > 0 && out[out.length - 1].kind === 'divider') {
    out.pop();
  }
  return out;
}
